<template>
    <div class="pic-btn-wrap">
        <el-button type="primary" size="mini" @click="handleSelectPic">{{selectImages.btnText}}</el-button>
        <el-dialog  :visible.sync="dialogFormVisiblePicList" center :fullscreen="true">
            <el-form :inline="true" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item>
                    <el-button type="success" @click="handleAddPic">新增</el-button>
                    <el-button type="warning" @click="dialogFormVisiblePicList = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="picList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="商品名称">
                    <template slot-scope="scope">{{selectImages.proName}}</template>
                </el-table-column>
                <el-table-column prop="fullRelativeUrl" label="图片" >
                    <template  slot-scope="scope">
                        <img :src="scope.row.fullRelativeUrl" width="120" height="80" class="head_pic"/>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column label="操作" fixed="right" width="80px">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleDetelePic(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="添加图片" :visible.sync="dialogFormVisiblePicAdd" center append-to-body>
                <el-form :model="formDetail" label-width="120px">
                    <el-form-item label="商品名称">{{selectImages.proName}}</el-form-item>
                    <el-form-item label="排序">
                        <el-input v-model="formDetail.sort" ></el-input>
                    </el-form-item>
                    <el-form-item label="选择图片">
                        <uploadComponents v-model="formDetail.fullRelativeUrl" :selectImages="formDetail.allFullRelativeUrl" @on-result-change="val=> formDetail.allFullRelativeUrl=val"></uploadComponents>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisiblePicAdd = false">取 消</el-button>
                    <el-button type="primary" @click="saveProductPic()">确 定</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getProductPics, addProductPic, removeProductPic} from '../api/api'
    import uploadComponents from '@/components/upload';

    //定义组件
    export default {
        props:['selectImages'],
        watch:{
            selectImages:function(val){
                this.selectImages = val;
                this.formDetail.proId = val.proId;
                this.formDetail.picType = val.picType;
            }
        },
        data() {
            return {
                picList: [],
                loading: true,
                dialogFormVisiblePicAdd: false,
                dialogFormVisiblePicList: false,
                formDetail: {
                    picType: this.selectImages.picType,
                    proId: this.selectImages.proId,
                    fullRelativeUrl: '',
                    allFullRelativeUrl:'',
                    sort:99
                }
            }
        },
        components:{
            uploadComponents
        },
        //挂载时候执行
        mounted() {
            // this.getProductPicsData();
        },
        created () {

        },
        methods: {
            handleSelectPic(){
                this.getProductPicsData();
                this.dialogFormVisiblePicList = true;
            },
            getProductPicsData() {
                this.loading = true;
                getProductPics({'picType':this.selectImages.picType,'proId':this.selectImages.proId}).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });

                        this.picList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleAddPic(){
                if(this.picList.length >= this.selectImages.limitCount){
                    this.$message({
                        showClose: true,
                        message: "最多上传" + this.selectImages.limitCount + "个",
                        type: 'error'
                    });
                    return;
                }
                this.formDetail.fullRelativeUrl='';
                this.formDetail.allFullRelativeUrl='';
                this.formDetail.sort=99;
                this.dialogFormVisiblePicAdd = true;
            },
            saveProductPic(){
                this.loading = true;
                addProductPic(this.formDetail).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '保存成功',
                            type: 'success'
                        });
                        this.getProductPicsData();
                        this.dialogFormVisiblePicAdd = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDetelePic(row){
                this.$confirm('删除图片, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    removeProductPic({picId:row.picId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getProductPicsData();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            }
        }
    }
</script>
<style scoped>
    .el-table__fixed-body-wrapper {
        z-index: auto;
    }
    .pic-btn-wrap{
       float:left;
        margin:0 5px 10px 5px;
    }
    .pic-btn-wrap .el-button{
        width: 100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/selectPic.vue